import { BusinessSteps, ErrorMessages, IndividualSteps } from '../../Types';

// This file will be used for exporting the constants
export {};
export enum ButtonColor {
  DARK_BLUE = 'text-white-0 bg-blue-1 hover:opacity-80 border border-blue-1',
  DARK_BLUE_2 = 'text-white-0 bg-blue-1 border border-blue-1',
  White = 'text-blue-1 bg-white-0 hover:opacity-80 border border-blue-1',
  Red = 'text-red-0 bg-white-0 hover:opacity-80 border border-red-0',
  RED_2 = 'text-white-0 bg-red-0 hover:opacity-80',
  SECONDARY = 'text-secondary-0 bg-secondary-1 hover:opacity-80 border border-secondary-2 font-bold',
}

export enum DashBoardTab {
  DASHBOARD,
  BILLING_HISTORY,
  MANAGE_USERS,
  MY_CARDS,
  SUBSCRIPTION,
  MANAGE_CUSTOMERS,
}

export enum Card {
  OTHER = 'other',
  BACKUP = 'backup',
  PRIMARY = 'primary',
}
export enum Navigation {
  DEFAULT = '/',
  SIGN_UP = '/signup',
  DASHBOARD = '/dashboard',
  BILLING_HISTORY = '/billingHistory',
  MANAGE_USERS = '/manageUsers',
  MY_CARDS = '/managePayment',
  SUBSCRIPTION = '/subscription',
  MANAGE_CUSTOMERS = '/manageCustomers',
}

export const BUSINESS_STEPS: BusinessSteps = [
  { 1: 'Business Information' },
  { 2: 'Support Package' },
  { 3: 'Upload Documents' },
  { 4: 'Permissions' },
  { 5: 'Payment Information' },
];

export const INDIVIDUAL_STEPS: IndividualSteps = [
  { 1: 'Contact Information' },
  { 2: 'Support Package' },
  { 3: 'Payment Information' },
];

export const BILLING_HISTORY_TABLE_HEADERS = [
  'Month',
  'Amount',
  'Document_No',
  'Status',
  'Paid_On',
];

export const MANAGE_CUSTOMER_TABLE_HEADERS = [
  'Name',
  'Domain',
  'Account_Type',
  'Created_At',
  'Status',
];

export const MANAGE_USERS_TABLE_HEADERS = ['Name', 'Email', 'Created_On', 'Status'];

export const RIGHT_ALIGN_HEADERS = ['Created_At', 'Paid_On', 'Amount', 'Month'];
export const LEFT_ALIGN_HEADERS = [
  'Amount',
  'Document_No',
  'Name',
  'Domain',
  'Account_Type',
  'Email',
];

export const ONBOARDING_STEPS = {
  INITIAL_DETAILS: 'Initial Details',
  BUSINESS_INFORMATION: 'Business Information',
  SUPPORT_PACKAGE: 'Support Package',
  UPLOAD_DOCUMENTS: 'Upload Documents',
  BILLING_EMAIL: 'Billing Email',
  PAYMENT_INFORMATION: 'Payment Information',
  CONTACT_INFORMATION: 'Contact Information',
  SUCCESS: 'Success',
  TERMS: 'Terms',
};

export enum TrackStep {
  GOOGLE = 'google-info',
  INFO = 'basic-info',
  PACKAGE = 'support-package',
  DOCUMENT = 'upload-documents',
  BILLING = 'billing-email',
  PAYMENT = 'payment-info',
  TERMS = 'terms-conditions',
  SUCCESS = 'success-creation',
  COMPLETED = 'onboarding-completed',
}

export const INDIVIDUAL = 'individual';

export const BUSINESS = 'business';

export const WHITE = '#FFFFFF';

export const GRAY = 'rgba(34, 34, 34, 0.7)';

export const BLUE = '#4285F4';

export const textFieldClass = 'border border-gray-2 p-2 w-full rounded-[4px]';

export const GRAY_2 = '#7B7B7B';

export const GREEN = '#00BC73';

export const BLUE_2 = '#2828F0';

export const supportPackages = [
  {
    packageName: 'Basic',
    price: 'Free',
    tagline: '',
    pointOne: 'Limited billing cases only',
    pointTwo: 'Response within 24 hours',
    color: GRAY_2,
  },
  {
    packageName: 'Standard',
    price: '$29',
    tagline: 'Plus 4% of monthly charges',
    pointOne: 'Business hours support',
    pointTwo: 'Response time 4 hours',
    commitments: '*90 days commitment',
    color: GREEN,
  },
  {
    packageName: 'Enhanced',
    price: '$500',
    tagline: 'Plus 5% of monthly charges',
    pointOne: '24x7 support for all cases',
    pointTwo: 'Response time 1 hour',
    commitments: '*90 days commitment',
    color: BLUE_2,
  },
];

export const BASIC = 'Basic';

export const STANDARD = 'Standard';

export const ENHANCED = 'Enhanced';

export const Admin = 'admin';

export const User = 'user';

export const UserRoles = [User, Admin];

export const Months: { [key: number]: string } = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

export const PER_PAGE_LIMIT = 10;

export const PER_PAGE_LIMIT_USERS = 9;

export const MAX_FILE_SIZE = 10240; // 10mb

export enum Role {
  USER = 'user',
  ADMIN = 'admin',
}

export enum SubscriptionStatus {
  CANCELLED = 'cancelled',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  PENDING = 'pending',
  PENDING_REVIEW = 'pending-review',
  PENDING_CANCELLATION = 'pending-cancellation',
}

export enum Moyassar3dSecureResponse {
  APPROVED = 'APPROVED',
  DECLINED_INVALID_PIN = '3-D Secure transaction attempt failed (DECLINED_INVALID_PIN)',
  DECLINED = 'DECLINED',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  UNSPECIFIED_FAILURE = 'UNSPECIFIED_FAILURE',
}

export enum Moyassar3dSecureStatusResponse {
  PAID = 'paid',
  FAILED = 'failed'
}

export const MoyassarErrorMessages: ErrorMessages = {
  [Moyassar3dSecureResponse.DECLINED_INVALID_PIN]: 'Wrong OTP',
  [Moyassar3dSecureResponse.DECLINED]: 'Card Declined',
  [Moyassar3dSecureResponse.INSUFFICIENT_FUNDS]: 'Insufficient Funds',
  [Moyassar3dSecureResponse.UNSPECIFIED_FAILURE]: 'Unspecified failure',
};

export const SUB_DURATION = 90;

// Invoice Status
export enum Status {
  UNPAID = 'pending',
  PAID = 'paid',
  FAILED = 'failed',
}

export const SaudiProvinces = [
  'Al Baha',
  'Al Jouf',
  'Al Qassim',
  'Asir',
  'Eastern Province',
  'Hail',
  'Jazan',
  'Madinah',
  'Makkah',
  'Najran',
  'Northern Borders',
  'Riyadh',
  'Tabuk',
];

export const SaudiCities = [
  'Abha',
  'Abqaiq',
  'Ad Dammam',
  'Ad Dawadami',
  "Al 'Uthmaniyah",
  'Al Baha',
  'Al Hada',
  'Al Hadithah',
  'Al Hasa',
  'Al Jubayl Industrial City',
  'Al Kharj',
  'Al Khobar',
  'Al Khuraibah',
  'Al Muajjiz',
  'Al Qahmah',
  'Al Qunfudah',
  'Al Qurainah',
  'Al Shuqaiq',
  'Ar Rass',
  'Arar',
  'Asfan',
  'Badanah',
  'Bisha',
  'Buraydah',
  'Dhahran',
  'Dhuba',
  'Fiji',
  'Gurayat',
  'Hafar al Batin',
  'Hail',
  'Harad',
  'Hazm Al Jalamid',
  'Hofuf',
  'Jazan Economic City',
  'Jeddah',
  'Jeddah Industrial City 2 & 3',
  'Jeddah Yachts Club Port',
  'Jizan',
  'Jouf',
  'Juaymah Terminal',
  'Jubail',
  'Khamis Mushayt',
  'King Abdullah City',
  'Lith',
  'Madinah',
  'Majma',
  'Makkah',
  'Manailih',
  'Manfouha',
  'Muhayil',
  'Najran',
  'Qaisumah',
  'Qalsn',
  'Qatif',
  'Qurayyah',
  'Rabigh',
  'Rafha',
  'Ras Al-Khair',
  'Ras Tanura',
  'Ras al Khafji',
  'Ras al Mishab',
  'Riyadh',
  'Riyadh Dry Port',
  'Safaniya',
  'Salboukh',
  'Salwá',
  'Sayhat',
  'Shadqam',
  'Sharurah',
  'Shuaibah',
  'Sulayel',
  'Tabuk',
  'Taif',
  'Turaif',
  'Tusdeer Free Zone',
  'Udhailiyah',
  'Umm Lajj',
  'Unayzah',
  'Wadi ad Dawasir',
  'Waisumah',
  'Wedjh',
  'Yanbu Industrial City',
  'Yanbu commercial city',
  'Zilfi',
  'Zulayfayn',
];

export const SaudiCityProvinces = [
  { city: "Abha", province: "Asir" },
  { city: "Abqaiq", province: "Eastern Province" },
  { city: "Ad Dammam", province: "Eastern Province" },
  { city: "Ad Dawadami", province: "Riyadh" },
  { city: "Al 'Uthmaniyah", province: "Eastern Province" },
  { city: "Al Baha", province: "Al Baha" },
  { city: "Al Hada", province: "Makkah" },
  { city: "Al Hadithah", province: "Al Jouf" },
  { city: "Al Hasa", province: "Eastern Province" },
  { city: "Al Jubayl Industrial City", province: "Eastern Province" },
  { city: "Al Kharj", province: "Riyadh" },
  { city: "Al Khobar", province: "Eastern Province" },
  { city: "Al Khuraibah", province: "Al Jouf" },
  { city: "Al Muajjiz", province: "Makkah" },
  { city: "Al Qahmah", province: "Jazan" },
  { city: "Al Qunfudah", province: "Makkah" },
  { city: "Al Qurainah", province: "Al Jouf" },
  { city: "Al Shuqaiq", province: "Jazan" },
  { city: "Ar Rass", province: "Al Qassim" },
  { city: "Arar", province: "Northern Borders" },
  { city: "Asfan", province: "Makkah" },
  { city: "Badanah", province: "Al Jouf" },
  { city: "Bisha", province: "Asir" },
  { city: "Buraydah", province: "Al Qassim" },
  { city: "Dhahran", province: "Eastern Province" },
  { city: "Dhuba", province: "Tabuk" },
  { city: "Fiji", province: "Makkah" },
  { city: "Gurayat", province: "Al Jouf" },
  { city: "Hafar al Batin", province: "Eastern Province" },
  { city: "Hail", province: "Hail" },
  { city: "Harad", province: "Eastern Province" },
  { city: "Hazm Al Jalamid", province: "Al Jouf" },
  { city: "Hofuf", province: "Eastern Province" },
  { city: "Jazan Economic City", province: "Jazan" },
  { city: "Jeddah", province: "Makkah" },
  { city: "Jeddah Industrial City 2 & 3", province: "Makkah" },
  { city: "Jeddah Yachts Club Port", province: "Makkah" },
  { city: "Jizan", province: "Jazan" },
  { city: "Jouf", province: "Al Jouf" },
  { city: "Juaymah Terminal", province: "Eastern Province" },
  { city: "Jubail", province: "Eastern Province" },
  { city: "Khamis Mushayt", province: "Asir" },
  { city: "King Abdullah City", province: "Makkah" },
  { city: "Lith", province: "Makkah" },
  { city: "Madinah", province: "Madinah" },
  { city: "Majma", province: "Riyadh" },
  { city: "Makkah", province: "Makkah" },
  { city: "Manailih", province: "Makkah" },
  { city: "Manfouha", province: "Riyadh" },
  { city: "Muhayil", province: "Asir" },
  { city: "Najran", province: "Najran" },
  { city: "Qaisumah", province: "Eastern Province" },
  { city: "Qalsn", province: "Al Jouf" },
  { city: "Qatif", province: "Eastern Province" },
  { city: "Qurayyah", province: "Eastern Province" },
  { city: "Rabigh", province: "Makkah" },
  { city: "Rafha", province: "Northern Borders" },
  { city: "Ras al Khafji", province: "Eastern Province" },
  { city: "Ras al Mishab", province: "Eastern Province" },
  { city: "Ras Al-Khair", province: "Eastern Province" },
  { city: "Ras Tanura", province: "Eastern Province" },
  { city: "Riyadh", province: "Riyadh" },
  { city: "Riyadh Dry Port", province: "Riyadh" },
  { city: "Safaniya", province: "Eastern Province" },
  { city: "Salboukh", province: "Riyadh" },
  { city: "Salwá", province: "Eastern Province" },
  { city: "Sayhat", province: "Eastern Province" },
  { city: "Shadqam", province: "Riyadh" },
  { city: "Sharurah", province: "Najran" },
  { city: "Shuaibah", province: "Makkah" },
  { city: "Sulayel", province: "Riyadh" },
  { city: "Tabuk", province: "Tabuk" },
  { city: "Taif", province: "Makkah" },
  { city: "Turaif", province: "Northern Borders" },
  { city: "Tusdeer Free Zone", province: "Eastern Province" },
  { city: "Udhailiyah", province: "Eastern Province" },
  { city: "Umm Lajj", province: "Tabuk" },
  { city: "Unayzah", province: "Al Qassim" },
  { city: "Wadi ad Dawasir", province: "Riyadh" },
  { city: "Waisumah", province: "Eastern Province" },
  { city: "Wedjh", province: "Tabuk" },
  { city: "Yanbu commercial city", province: "Madinah" },
  { city: "Yanbu Industrial City", province: "Madinah" },
  { city: "Zilfi", province: "Riyadh" },
  { city: "Zulayfayn", province: "Riyadh" }
];

export const OrganizationTypes = [
  'Private Sector',
  'Non-profit/Charity',
  'Government/Public Sector',
  'Semi-Government',
  'Independent',
];

export const BILLING_STATUS = {
  PENDING: 'pending',
  FAILED: 'failed',
  PAID: 'paid',
};

export interface SupportFormData {
  subject: string;
  email: string;
  message: string;
  name: string;
  file: File | null;
}

export const NAME_REGEX = /[^a-zA-Z0-9\s.-]|-{2,}|\.{2,}|\s{2,}|\.\s|\s\.|\s-|-\s|\.-|-\./g;

export const ACCOUNT_NAME_REGEX = /[.\-\s]+$/g;

export enum NafathRequestStatus {
  PENDING = 'pending',
  WAITING = 'waiting',
  EXPIRED = 'expired',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
  ERROR = 'error',
  CANCELLED = 'cancelled',
  STATUS_WATING = 'status-waiting',
}

export const NAFATH_VERIFICATION_SECONDS = 180;

export enum StatusReason {
  BUDGET_OVERAGE = 'budget-overage',
  FAILED_PAYMENT = 'failed-payment',
  SECURITY = 'security',
  PENDING_REVIEW = 'pending-review',
  FAILED_SETTLEMENT = 'failed-settlement',
  TERMS_VIOLATION = 'terms-violation',
}

export enum ToastStatus {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SECONDARY = 'secondary',
}

export enum InvoiceType {
  MONTHLY = 'monthly',
  THRESHOLD = 'threshold',
  SETTLEMENT = 'settlement',
}

export enum CardType {
  VISA = 'visa',
  MASTER = 'master',
  MADA = 'mada',
  AMEX = 'amex',
}

export const RestrictedCardTypes: Partial<Record<CardType, string>> = {
  [CardType.MADA]: 'Mada',
  [CardType.AMEX]: 'American Express',
};
